<template>
  <a-modal
    :width="800"
    centered
    :footer="null"
    @cancel="$emit('close')"
    :visible="visible"
    :title="title"
    class="detail-modal"
  >
    <a-table :columns="columns" :data-source="data"></a-table>
  </a-modal>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default: function() {
        return []
      }
    },
    data: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="less">
.detail-modal {
  .ant-modal-title,
  .ant-table-column-title {
    font-weight: 600;
  }
}
</style>
